<template>

  <section class="pb-5 nooverflow" style="background: linear-gradient(rgb(255, 255, 255) 21%, rgb(227, 229, 230) 100%);position: relative;" @mouseover="wonderMouseOver" @mouseleave="wonderMouseOut">
			<img src="../../../assets/wonderbw.png" id="wonder" class="wonder"/>
			<div style="height: 86px;width: 177px;position: absolute;bottom:60px;transform: skew(-71deg, 7deg);left: 24%;z-index: 1;border-radius: 147px;background: rgba(241, 241, 241, 0.81);"></div>

			<v-layout column align-center class="pt-3 pb-2" style="position:relative;z-index:2">

				<v-flex xs12 sm4>
					<div class="text-xs-center">
						<h2 class="display-2 font-weight-light mt-5 mb-3">
							How It Works
						</h2>
						<br/>
					</div>
				</v-flex>

				<v-container grid-list-xl class="">
				<v-layout row  wrap class="mb-5" style="position:relative;z-index:2">
				<div class="try-it-axis hidden-md-and-down"></div>
				<v-flex sm12 lg3>

						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon primary--text">touch_app</v-icon>
								<div class="how-it-works-text font-weight-light"><b class="how-it-works-number">1. </b>Login with your GMail account</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>
				<v-flex sm12 lg3>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon primary--text">card_giftcard</v-icon>
								<div class="how-it-works-text font-weight-light"><b class="how-it-works-number">2. </b>Get 100 free words</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>
				<!--
				<v-flex sm12 lg4>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon primary--text">record_voice_over</v-icon>
								<div class="how-it-works-text font-weight-light"><b class="how-it-works-number">3. </b>Select language & character</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>
				-->
				<v-flex sm12 lg3>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon primary--text">movie</v-icon>
								<div class="how-it-works-text font-weight-light"><b class="how-it-works-number">3. </b>Generate your files</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>

				<!--
				<v-flex sm12 lg4>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon primary--text">save_alt</v-icon>
								<div class="how-it-works-text font-weight-light"><b class="how-it-works-number">5. </b>Download them to your device</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>
				-->
				<v-flex sm12 lg3>
						<v-layout column align-center>
						<div class="how-it-works-container">
							<v-layout column>
								<v-icon class="how-it-works-icon primary--text">accessibility_new</v-icon>
								<div class="how-it-works-text font-weight-light"><b class="how-it-works-number">4. </b>Be Happy</div>
							</v-layout>
						</div>
						</v-layout>
				</v-flex>

				</v-layout>
				</v-container>

				<!--
				<v-flex xs12 sm4 class="mt-5 relative">
					<v-btn class="mt-5 round-button elevation-0" dark large @click='login()' color="rgb(15, 188, 218)" style="box-shadow:-1px 0px 17px -3px rgb(15, 188, 218) !important">See for Yourself</v-btn>
					<img src="../../../assets/hint1.png" style="position: absolute;bottom: 7px;right: -291px;transform: rotate(1deg);"/>
				</v-flex>
					-->
			</v-layout>

			<div style="height: 213px;width: 109%;background: white;position: absolute;top: -181px;left: -20px;transform: rotate(178deg);z-index: 1;">.</div>

		</section>


</template>

<style>

@keyframes how-it-works-ani-1 {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.05);
  }
  40% {
    transform: scale(1.08);
  }
  60% {
    transform: scale(1.1);
  }
  80% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes wonder-ani {
  0% {
    transform: rotate(0deg);
  }
  40% {
    transform: rotate(-1deg);
  }
  60% {
    transform: rotate(1deg);
  }
  100% {
    transform: rotate(0deg);
  }
}


.wonder {
		position: absolute;
    left: 23%;
    bottom: 86px;
    z-index: 10;
    -webkit-transition: left 0.8s;
    transition: left 0.8s;
    -webkit-animation: none;
    animation: none;
    opacity: 0.9;
	}

	.wonder-active {
		--left:10px !important;
		--animation:wonder-ani 4s infinite !important;
	}

  .how-it-works-icon {
	font-size: 55px;
    --color: rgb(255, 143, 84) !important;
    background: #ffffff;
    border-radius: 115px;
    height: 165px;
    margin-left: 28px;
    margin-right: 28px;
    transition:transform 4s;
    box-shadow: 0px 8px 18px -7px rgba(138, 135, 135, 0.13);
}

.how-it-works-container {
	position: relative;
    width: 220px;
    height: 260px;
    background: transparent;
    padding: 30px 10px 10px;
    margin: 0px 1px;
}

.how-it-works-container:hover .how-it-works-text {
	color:#179557 !important;
}

.how-it-works-container:hover  .how-it-works-icon {
    box-shadow:-8px 3px 30px -12px rgba(165, 165, 165, 0.68);
    -webkit-box-shadow:-8px 3px 30px -12px rgba(165, 165, 165, 0.68);
	transform:scale(1.1);
	background:#179557 !important;
	color:white !important;
	transition:transform 0.6s;
}

.how-it-works-text {
	padding-top:28px;
	text-align:center;
	font-size:1.2rem;
	word-wrap:break-word;
	--color: #f96c22;
}

.how-it-works-number {
	color:black;
}

.try-it-axis {
	height: 14px;
	width: 100%;
	background: transparent;
	position: absolute;
	top: 93px;
	z-index: 0;
	border-top: 2px dotted rgb(152, 152, 152);;
}

</style>

<script>

export default {
  name: "how_it_works_section",
  data() {
    return {
    };
  },
  methods : {
  		wonderMouseOver : function() {
			this.in('wonder', 'wonder-active');
		},
		wonderMouseOut : function() {
			this.out('wonder', 'wonder-active');
		},
  		in : function(id, cls) {
			document.getElementById(id).classList.add(cls);
		},
		out : function(id, cls) {
			document.getElementById(id).classList.remove(cls);
		}
  }
};
</script>
